import { DateTime } from 'luxon';
import { longWeekDay, weekDayMonthDay } from '../../../constants/dateStrings';
import {
  IFulfillmentGroup,
  IOrderDetailsResponse,
  IReturnShipments,
} from '../../../models/order-details';

interface IAddress {
  city?: string;
  state?: string;
}

// TODO: Replace Luxon's DateTime.local().toLocaleString(DateTime.DATE_HUGE) with Day.js equivalent
// const formattedDate = dayjs().format('MMMM D, YYYY');

export const FILLER = '----'; // confirm this with UX, could be N/A too.

export const formatCityState = (address: IAddress | undefined) => {
  if (address) {
    const { city, state } = address;
    return city && state ? `${city}, ${state.toUpperCase()}` : '----';
  }
  return '----';
};

export const formatDateTime = (
  date?: string,
  startTime?: string,
  endTime?: string,
  dateFormatStr: string = weekDayMonthDay,
  timeFormatStr = 'h a',
): string => {
  if (!date || !startTime || !endTime) return '';
  const start = dateFormat(startTime, timeFormatStr);
  const end = dateFormat(endTime, timeFormatStr);
  return `${dateFormat(date, dateFormatStr)}, ${start} - ${end}`;
};

export const dateFormat = (
  date: string | undefined,
  format: string,
  localTimezone?: boolean,
) => {
  if (date === undefined || date === null || date === '') return '';

  let dateTime = DateTime.fromISO(date, { zone: 'utc' });
  if (localTimezone) {
    const localZone = DateTime.local().zoneName;
    dateTime = dateTime.setZone(localZone);
  }

  const formattedDate = dateTime.toFormat(format);
  const isLongWeekDayFormat = format.includes(longWeekDay);

  if (isLongWeekDayFormat) {
    return formattedDate;
  }

  return formattedDate.replace('Tue', 'Tues').replace('Thu', 'Thurs');
};

export const timeFormat = (time: string) =>
  time[0] === '0' ? time.slice(1) : time;

export const formatAMPM = (time: string): string => {
  const regExAM = new RegExp(' am', 'ig');
  const regExPM = new RegExp(' pm', 'ig');
  const replaceValueAM = ' a.m.';
  const replaceValuePM = ' p.m.';

  return time.replace(regExAM, replaceValueAM).replace(regExPM, replaceValuePM);
};

export const capitalizeAMPM = (time: string): string => {
  const regExAM = new RegExp('(\\d\\s*)am\\b', 'ig');
  const regExPM = new RegExp('(\\d\\s*)pm\\b', 'ig');
  const replaceValueAM = '$1AM';
  const replaceValuePM = '$1PM';

  return time.replace(regExAM, replaceValueAM).replace(regExPM, replaceValuePM);
};

export const renderOrderTotal = (orderDetailsData: IOrderDetailsResponse) => {
  let hasReturnedItemStatus = false;
  const {
    grandTotalAmount = 0,
    returnTotal = 0,
    statusDescription = '',
  } = orderDetailsData;

  if (statusDescription !== 'Returned') {
    orderDetailsData.fulfillmentGroups?.forEach((group: IFulfillmentGroup) => {
      group?.returnShipments?.forEach((item: IReturnShipments) => {
        if (item.returnStatus === 'Return Completed') {
          hasReturnedItemStatus = true;
        }
      });
    });
  }

  return grandTotalAmount?.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
